import { render, staticRenderFns } from "./voiceComposePlayer.vue?vue&type=template&id=8f2cb89a&scoped=true&"
import script from "./voiceComposePlayer.vue?vue&type=script&lang=js&"
export * from "./voiceComposePlayer.vue?vue&type=script&lang=js&"
import style0 from "./voiceComposePlayer.vue?vue&type=style&index=0&id=8f2cb89a&lang=less&scoped=true&"
import style1 from "./voiceComposePlayer.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2cb89a",
  null
  
)

component.options.__file = "voiceComposePlayer.vue"
export default component.exports